<template>
  <div class="home-page">

    <!-- ── Banner Carousel ──────────────────────────────────── -->
    <div class="carousel-wrapper">
      <b-carousel
        id="main-carousel"
        :interval="5000"
        controls
        indicators
        fade
        class="main-carousel"
      >
        <b-carousel-slide img-src="https://consularlao.gov.la/img/banner1.jpeg" img-alt="Banner 1"></b-carousel-slide>
        <b-carousel-slide img-src="https://consularlao.gov.la/img/banner2.jpeg" img-alt="Banner 2"></b-carousel-slide>
      </b-carousel>
    </div>

    <!-- ── Service Quick-Access Cards ──────────────────────── -->
    <div class="services-section">
      <b-container fluid class="px-4">
        <b-row class="service-row">

          <b-col cols="6" md="3" class="mb-3 mb-md-0">
            <router-link to="/registerqueue" class="svc-card">
              <div class="svc-icon-wrap svc-blue">
                <b-icon icon="calendar-check-fill" font-scale="2"></b-icon>
              </div>
              <div class="svc-label">{{ $t('HomePage.RegisterQueue') }}</div>
            </router-link>
          </b-col>

          <b-col cols="6" md="3" class="mb-3 mb-md-0">
            <router-link to="/listqueue" class="svc-card">
              <div class="svc-icon-wrap svc-red">
                <b-icon icon="list-ul" font-scale="2"></b-icon>
              </div>
              <div class="svc-label">{{ $t('HomePage.listqueue') }}</div>
            </router-link>
          </b-col>

          <b-col cols="6" md="3" class="mb-3 mb-md-0">
            <router-link to="/qrscanqr" class="svc-card">
              <div class="svc-icon-wrap svc-gold">
                <b-icon icon="qr-code-scan" font-scale="2"></b-icon>
              </div>
              <div class="svc-label">{{ $t('HomePage.qrscan') }}</div>
            </router-link>
          </b-col>

          <b-col cols="6" md="3">
            <router-link to="/visadocument" class="svc-card">
              <div class="svc-icon-wrap svc-green">
                <b-icon icon="card-text" font-scale="2"></b-icon>
              </div>
              <div class="svc-label">{{ $t('HomePage.visadocument') }}</div>
            </router-link>
          </b-col>

        </b-row>
      </b-container>
    </div>

    <!-- ── Main 3-column Layout ──────────────────────────── -->
    <b-container fluid class="px-4 py-4">
      <b-row>

        <!-- Left sidebar -->
        <b-col md="3" class="mb-4">

          <!-- Menu -->
          <div class="panel mb-4">
            <div class="panel-header">
              <b-icon icon="grid-fill" class="mr-2"></b-icon>ເມນູຫຼັກ
            </div>
            <div class="panel-body p-0">
              <router-link to="/info" class="sidebar-link">
                <b-icon icon="megaphone-fill" class="sl-icon sl-blue"></b-icon>
                {{ $t('HomePage.info') }}
              </router-link>
              <router-link to="/law" class="sidebar-link">
                <b-icon icon="book-fill" class="sl-icon sl-blue"></b-icon>
                {{ $t('HomePage.law') }}
              </router-link>
              <router-link to="/document" class="sidebar-link">
                <b-icon icon="file-earmark-text-fill" class="sl-icon sl-blue"></b-icon>
                {{ $t('HomePage.document') }}
              </router-link>
              <router-link to="/about" class="sidebar-link">
                <b-icon icon="info-circle-fill" class="sl-icon sl-blue"></b-icon>
                {{ $t('HomePage.aboutus') }}
              </router-link>
              <router-link to="/contract" class="sidebar-link last">
                <b-icon icon="telephone-fill" class="sl-icon sl-blue"></b-icon>
                {{ $t('HomePage.contract') }}
              </router-link>
            </div>
          </div>

          <!-- External sites -->
          <div class="panel mb-4">
            <div class="panel-header">
              <b-icon icon="globe" class="mr-2"></b-icon>ເວັບໄຊທ໌
            </div>
            <div class="panel-body p-0">
              <a href="http://www.mofa.gov.la/index.php/lo/" target="_blank" class="sidebar-link">
                <b-icon icon="box-arrow-up-right" class="sl-icon sl-gold"></b-icon>
                ກະຊວງການຕ່າງປະເທດ
              </a>
              <a href="https://immigration.gov.la/" target="_blank" class="sidebar-link last">
                <b-icon icon="box-arrow-up-right" class="sl-icon sl-gold"></b-icon>
                ກົມຕໍາຫຼວດ ຕຄມ
              </a>
            </div>
          </div>

          <!-- eVISA Banner -->
          <div class="panel">
            <div class="panel-header">
              <b-icon icon="credit-card-fill" class="mr-2"></b-icon>eVISA
            </div>
            <div class="panel-body text-center py-3">
              <a href="https://laoevisa.gov.la/index" target="_blank">
                <b-img :src="require('../assets/eVisax200W.png')" fluid class="evisa-img"></b-img>
              </a>
              <p class="evisa-caption">ຍື່ນຂໍວີຊ່າອອນລາຍ</p>
            </div>
          </div>

        </b-col>

        <!-- Center content -->
        <b-col md="6" class="mb-4">
          <div class="panel h-100">
            <div class="panel-header panel-header-red">
              <b-icon icon="megaphone-fill" class="mr-2"></b-icon>
              {{ $t('HomePage.info') }}
            </div>
            <div class="panel-body">
              <div v-if="newsItems.length === 0" class="empty-state">
                <b-icon icon="inbox" font-scale="2.5" class="empty-icon"></b-icon>
                <p class="mt-2">ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
              </div>
              <div
                v-for="(item, i) in newsItems"
                :key="i"
                class="news-item"
              >
                <div class="news-num">{{ i + 1 }}</div>
                <a :href="item.link" target="_blank" class="news-title">{{ item.title }}</a>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Right column: Calendar -->
        <b-col md="3" class="mb-4">
          <div class="panel mb-4">
            <div class="panel-header">
              <b-icon icon="calendar3" class="mr-2"></b-icon>ປະຕິທິນ
            </div>
            <div class="panel-body p-2">
              <b-calendar block locale="lo" v-model="today" class="cal-custom"></b-calendar>
            </div>
          </div>

          <!-- Open hours info card -->
          <div class="panel">
            <div class="panel-header panel-header-gold">
              <b-icon icon="clock-fill" class="mr-2"></b-icon>ເວລາບໍລິການ
            </div>
            <div class="panel-body py-3">
              <div class="hours-row">
                <span class="hours-day">ຈັນ – ສຸກ</span>
                <span class="hours-time">08:00 – 16:00</span>
              </div>
              <div class="hours-row">
                <span class="hours-day">ເສົາ – ອາທິດ</span>
                <span class="hours-time closed">ປິດ</span>
              </div>
              <hr class="my-2">
              <div class="text-center">
                <b-icon icon="telephone-fill" class="mr-1" style="color:#002868;"></b-icon>
                <small>021 254 176</small>
              </div>
            </div>
          </div>

        </b-col>

      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      today: new Date(),
      newsItems: [],
    };
  },
  created() {
    axios
      .get(this.$store.getters.getBaseUrl + "/info/1/1", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer anUrbLQdEVK7V/w3Mjkp28ZDJXgDH7SpKeqtKBjkqMnNJT4OQ?ukI8w7M5/HmxsONU78KEg4p=!5r0WOf=5/zBa9h/PTI42lb5JEhR855=LTAt!!AeJBFkmFtrpOwS7KhMuk!=B=8Rn=aqz6U59ZoPATYEKFkaZ-C/4ZRUXjUfb4DA0-69KsueEHkI/RW8mD2lLudpbe5JZpti=uQmQe5Nq2G6pP9//DX9hGm3yFpVMInuh-O50nbYdMej1miJTs",
          "Accept-Encoding": "identity",
        },
      })
      .then((r) => {
        this.newsItems = r.data;
      })
      .catch(() => {});
  },
};
</script>

<style scoped>
/* ── Page base ─────────────────────────────────────────── */
.home-page {
  background: #f4f6fb;
}

/* ── Carousel ──────────────────────────────────────────── */
.carousel-wrapper {
  border-bottom: 4px solid #d4af37;
  overflow: hidden;
}
.main-carousel >>> .carousel-item img {
  max-height: 400px;
  width: 100%;
  object-fit: cover;
}
.main-carousel >>> .carousel-control-prev-icon,
.main-carousel >>> .carousel-control-next-icon {
  background-color: rgba(0, 40, 104, 0.6);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-size: 55%;
}
.main-carousel >>> .carousel-indicators li {
  background-color: #d4af37;
  width: 28px;
  height: 4px;
  border-radius: 2px;
}

/* ── Service Cards ─────────────────────────────────────── */
.services-section {
  background: #002868;
  padding: 20px 0;
}
.service-row {
  margin: 0;
}
.svc-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 10px;
  padding: 18px 12px 14px;
  text-decoration: none;
  transition: background 0.25s, transform 0.2s;
  cursor: pointer;
  height: 100%;
}
.svc-card:hover {
  background: rgba(255,255,255,0.15);
  transform: translateY(-3px);
  text-decoration: none;
}
.svc-icon-wrap {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  color: #fff;
}
.svc-blue  { background: #1B3A6B; box-shadow: 0 4px 12px rgba(27,58,107,0.5); }
.svc-red   { background: #CE1126; box-shadow: 0 4px 12px rgba(206,17,38,0.5); }
.svc-gold  { background: #B8860B; box-shadow: 0 4px 12px rgba(184,134,11,0.4); }
.svc-green { background: #1a7340; box-shadow: 0 4px 12px rgba(26,115,64,0.4); }
.svc-label {
  color: #e8f0ff;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
}

/* ── Panels ────────────────────────────────────────────── */
.panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  overflow: hidden;
}
.panel-header {
  background: #002868;
  color: #fff;
  font-weight: 700;
  font-size: 0.88rem;
  padding: 11px 16px;
  border-left: 4px solid #d4af37;
  display: flex;
  align-items: center;
  letter-spacing: 0.2px;
}
.panel-header-red {
  border-left-color: #ce1126;
}
.panel-header-gold {
  background: #b8860b;
  border-left-color: #fff3;
}
.panel-body {
  padding: 12px;
}

/* ── Sidebar links ──────────────────────────────────────── */
.sidebar-link {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  color: #2c3e50;
  text-decoration: none;
  font-size: 0.87rem;
  border-bottom: 1px solid #f0f2f7;
  transition: background 0.18s, color 0.18s, padding-left 0.18s;
}
.sidebar-link:hover {
  background: #eaf1fb;
  color: #002868;
  padding-left: 20px;
  text-decoration: none;
}
.sidebar-link.last {
  border-bottom: none;
}
.sl-icon {
  width: 18px;
  margin-right: 10px;
  flex-shrink: 0;
}
.sl-blue { color: #1B3A6B; }
.sl-gold { color: #b8860b; }

/* eVISA */
.evisa-img {
  border-radius: 6px;
  max-width: 160px;
}
.evisa-caption {
  font-size: 0.78rem;
  color: #888;
  margin: 6px 0 0;
}

/* ── News list ─────────────────────────────────────────── */
.empty-state {
  text-align: center;
  color: #aaa;
  padding: 40px 0;
}
.empty-icon { color: #ccc; }
.news-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #f0f2f7;
}
.news-item:last-child { border-bottom: none; }
.news-num {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #002868;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  margin-top: 1px;
}
.news-title {
  font-size: 0.88rem;
  color: #2c3e50;
  text-decoration: none;
  line-height: 1.5;
  transition: color 0.18s;
}
.news-title:hover { color: #002868; text-decoration: underline; }

/* ── Calendar ──────────────────────────────────────────── */
.cal-custom >>> .b-calendar-grid-caption {
  background: #002868 !important;
  color: #fff !important;
  font-weight: 600;
}
.cal-custom >>> header .btn {
  color: #fff !important;
}
.cal-custom >>> .btn-outline-primary {
  border-color: #002868 !important;
  color: #002868 !important;
}
.cal-custom >>> .btn-primary {
  background: #002868 !important;
  border-color: #002868 !important;
}

/* ── Office Hours ──────────────────────────────────────── */
.hours-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.87rem;
  padding: 5px 0;
  border-bottom: 1px dashed #eee;
}
.hours-row:last-child { border: none; }
.hours-day { color: #555; }
.hours-time { font-weight: 700; color: #002868; }
.hours-time.closed { color: #ce1126; }
</style>
